export const ACTION_CATEGORIES = {
  admin: [
    'company.',
    'user.',
    'plan.',
    'system.',
    'module.',
    'company_plan.',
    'permission.',
    'role.',
  ],
  billing: [
    'billing.',
  ],
  payments: [
    'mp.',
  ],
  system: [
    'permission.',
    'role.',
    'settings.',
  ],
} as const;

export const CATEGORY_COLORS = {
  admin: {
    bg: 'bg-blue-50 dark:bg-blue-950',
    text: 'text-blue-700 dark:text-blue-300',
    border: 'border-blue-200 dark:border-blue-800',
    badge: 'bg-blue-100 dark:bg-blue-900 text-blue-700 dark:text-blue-300',
  },
  billing: {
    bg: 'bg-green-50 dark:bg-green-950',
    text: 'text-green-700 dark:text-green-300',
    border: 'border-green-200 dark:border-green-800',
    badge: 'bg-green-100 dark:bg-green-900 text-green-700 dark:text-green-300',
  },
  payments: {
    bg: 'bg-amber-50 dark:bg-amber-950',
    text: 'text-amber-700 dark:text-amber-300',
    border: 'border-amber-200 dark:border-amber-800',
    badge: 'bg-amber-100 dark:bg-amber-900 text-amber-700 dark:text-amber-300',
  },
  system: {
    bg: 'bg-purple-50 dark:bg-purple-950',
    text: 'text-purple-700 dark:text-purple-300',
    border: 'border-purple-200 dark:border-purple-800',
    badge: 'bg-purple-100 dark:bg-purple-900 text-purple-700 dark:text-purple-300',
  },
  error: {
    bg: 'bg-red-50 dark:bg-red-950',
    text: 'text-red-700 dark:text-red-300',
    border: 'border-red-200 dark:border-red-800',
    badge: 'bg-red-100 dark:bg-red-900 text-red-700 dark:text-red-300',
  },
} as const;

export function getActionCategory(action: string): keyof typeof ACTION_CATEGORIES {
  for (const [category, prefixes] of Object.entries(ACTION_CATEGORIES)) {
    if (prefixes.some(prefix => action.startsWith(prefix))) {
      return category as keyof typeof ACTION_CATEGORIES;
    }
  }
  return 'system';
}
